/// <amd-module name="Feed/Legacy/Protocols/Ivy/IvyFileHelper" />
import * as Utils_String from "VSS/Core/Util/String";

import { IError } from "Feed/Common/Types/IError";

import * as PackageResources from "Feed/Common/Resources";

import { PackageVersion } from "Feed/Common/Contracts/Feed";

import * as Actions from "Feed/Legacy/Actions/Actions";
import { IIvyRestClient } from "Feed/Common/Protocols/Ivy/RestClient/Ivy";
import { IVssPageContext } from "VSS/Platform/Context";

export interface IIvyFile {
    name: string;
    key: string;
}

export function getFiles(packageVersion: PackageVersion): IIvyFile[] {
    const fileNames: IIvyFile[] = [];

    if (packageVersion.files) {
        packageVersion.files.forEach(file => {
            fileNames.push({
                name: file.name,
                key: file.name
            });
        });
    }

    return fileNames;
}

export function getHrefLink(
    pageContext: IVssPageContext,
    ref: string,
    feedId: string,
    normalizedName: string,
    normalizedVersion: string,
    callback: (href: string) => void
): void {
    pageContext
        .getRestClient<IIvyRestClient>("IIvyRestClient")
        .packageInfo(feedId, normalizedName, normalizedVersion)
        .then(
            x => {
                const data = ref.indexOf(".") !== -1 ? x.files : x;
                const item = data[ref];
                const link = item ? item.href : null;
                if (link) {
                    if (callback) {
                        callback(link);
                    }
                } else {
                    Actions.ErrorEncountered.invoke({
                        message: Utils_String.format(PackageResources.Ivy_File_NotFound, ref)
                    } as IError);
                }
            },
            error => {
                Actions.ErrorEncountered.invoke({
                    message: Utils_String.format(PackageResources.Ivy_File_NotFound, ref),
                    details: error
                } as IError);
            }
        );
}
